export default "__VITE_ASSET__MlTH2qJg__"